

export default {
  methods: {
    getRouter(path) {
      const locale = this.$i18n.locale;
      const pre = (locale == 'en' ? '/en' : '');
      return pre + path;
    },
    close() {

    }
  }
}
